export enum ROLES {
  SUPERADMIN = "superadmin",
  ADMIN = "admin",
  RANGER = "ranger",
  USER = "user",
}
